var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3157_15815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.98561 0.111954C5.50487 0.286458 8.59867 -0.213301 11.0517 0.111954C12.6037 0.317522 13.7808 1.75924 13.9189 3.24207C13.9758 3.85238 14.1315 5.39643 13.3051 5.47866C12.1579 5.59195 12.6047 3.81127 12.5133 3.15711C12.4088 2.40792 11.74 1.60849 10.9603 1.48058H3.07702C2.21426 1.66422 1.71246 2.34123 1.52405 3.15711L1.51566 15.758C1.6509 16.5337 2.12752 17.2591 2.93245 17.4765C5.38735 17.3916 8.38788 17.8045 10.7971 17.5396C11.7671 17.4327 12.365 16.6588 12.5226 15.758L12.5422 7.28035C12.8845 6.47726 13.931 6.77511 13.9254 7.62205C13.7239 10.2561 14.1856 13.2464 13.9095 15.8375C13.3993 20.6322 6.29954 18.4094 3.06489 18.9C1.44384 18.6551 0.254634 17.3569 0.113795 15.7607C-0.244367 11.7179 0.38055 7.16341 0.126853 3.06757C0.368425 1.57286 1.43265 0.381477 2.98561 0.111954Z",
    fill: "#0877FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15307 14.9096C6.43474 14.8484 7.69297 14.8503 7.95693 14.9307C8.60143 15.128 8.552 16.0946 7.88511 16.2408C7.60343 16.302 6.3452 16.3002 6.08125 16.2198C5.43581 16.0225 5.48804 15.0549 6.15307 14.9096Z",
    fill: "#0877FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3157_15815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fcca96ad631c205c3e5619feb3c30302.svg";
export { ForwardRef as ReactComponent };